import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  ADD_NEW_EVENT,
  DELETE_EVENT,
  GET_CATEGORIES,
  GET_EVENTS,
  UPDATE_EVENT,
} from "./actionTypes"
import {
  getEventsSuccess,
  getEventsFail,
  addEventFail,
  addEventSuccess,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
  getCategoriesSuccess,
  getCategoriesFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
} from "../../helpers/fakebackend_helper"

interface CalendarAction {
  type: string;
  payload?: any;
}

function* fetchEvents(): Generator<any, void, any> {
  try {
    const response = yield call(getEvents)
    yield put(getEventsSuccess(response))
  } catch (error) {
    yield put(getEventsFail(error))
  }
}

function* onAddNewEvent(action: CalendarAction): Generator<any, void, any> {
  try {
    const response = yield call(addNewEvent, action.payload)
    yield put(addEventSuccess(response))
  } catch (error) {
    yield put(addEventFail(error))
  }
}

function* onUpdateEvent(action: CalendarAction): Generator<any, void, any> {
  try {
    const response = yield call(updateEvent, action.payload)
    yield put(updateEventSuccess(response))
  } catch (error) {
    yield put(updateEventFail(error))
  }
}

function* onDeleteEvent(action: CalendarAction): Generator<any, void, any> {
  try {
    const response = yield call(deleteEvent, action.payload)
    yield put(deleteEventSuccess(response))
  } catch (error) {
    yield put(deleteEventFail(error))
  }
}

function* onGetCategories(): Generator<any, void, any> {
  try {
    const response = yield call(getCategories)
    yield put(getCategoriesSuccess(response))
  } catch (error) {
    yield put(getCategoriesFail(error))
  }
}

function* calendarSaga(): Generator<any, void, any> {
  yield takeEvery(GET_EVENTS as any, fetchEvents)
  yield takeEvery(ADD_NEW_EVENT as any, onAddNewEvent)
  yield takeEvery(UPDATE_EVENT as any, onUpdateEvent)
  yield takeEvery(DELETE_EVENT as any, onDeleteEvent)
  yield takeEvery(GET_CATEGORIES as any, onGetCategories)
}

export default calendarSaga
